module.exports = __webpack_public_path__ + "lm-icon-collect.0e7e92fa00587f6df1d36b5c5a85b11b.png";